import type { ModelData } from '../../types'

export const dragonProste: { [key: string]: ModelData } = {
  'dragon-2-slim': {
    id: 'dragon-2-slim',
    name: 'DRAGON 2 SLIM',
    power: '8 kW',
    type: 'powietrzny',
    glassType: 'prosta' as const,
    image: 'images/dragon-2-slim.jpg',
    emailSubject: 'Zapytanie - DRAGON 2 SLIM',
    description: 'Wkład powietrzny prosty 8 kW',
    basePrices: {
      standard: { single: 8140, double: 8780, triple: 9530 },
      lift: { single: 10480, double: 11720, triple: 12470 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 360, 'flush-30': 410, 'recessed-15': 450, 'recessed-30': 530, 'recessed-15-45': 560 },
        lift: { none: 0, 'recessed-lift-15': 430, 'recessed-lift-30': 500, 'recessed-lift-5': 950 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '8 kW',
      efficiency: '77,0%',
      energyClass: 'A',
      glassSize: '655 x 471 mm',
      insertSize: '708 x 1168-1446 x 400 mm',
      fireplaceSize: '445 x 500 x 234 mm',
      maxLogLength: '490 mm',
      weight: '163 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'Moduły FUSION'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 2 SLIM',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 2 SLIM w konfiguracji:\n\nModel: DRAGON 2 SLIM\nMoc: 6 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-2': {
    id: 'dragon-2',
    name: 'DRAGON 2',
    power: '13 kW',
    type: 'powietrzny',
    glassType: 'prosta' as const,
    image: 'images/dragon-2.jpg',
    emailSubject: 'Zapytanie - DRAGON 2',
    description: 'Wkład powietrzny prosty 13 kW',
    basePrices: {
      standard: { single: 8190, double: 8830, triple: 9580 },
      lift: { single: 11130, double: 11770, triple: 12520 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 360, 'flush-30': 410, 'recessed-15': 450, 'recessed-30': 530, 'recessed-15-45': 560 },
        lift: { none: 0, 'recessed-lift-15': 430, 'recessed-lift-30': 500, 'recessed-lift-5': 950 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '13 kW',
      efficiency: '77,3%',
      energyClass: 'A',
      glassSize: '655 x 471 mm',
      insertSize: '708 x 1129-1284 x 450 mm',
      fireplaceSize: '445 x 500 x 254 mm',
      maxLogLength: '490 mm',
      weight: '163 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 2',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 2 w konfiguracji:\n\nModel: DRAGON 2\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-4': {
    id: 'dragon-4',
    name: 'DRAGON 4',
    power: '15,5 kW',
    type: 'powietrzny',
    glassType: 'prosta' as const,
    image: 'images/dragon-4.jpg',
    emailSubject: 'Zapytanie - DRAGON 4',
    description: 'Wkład powietrzny prosty 15,5 kW',
    basePrices: {
      standard: { single: 9100, double: 9850, triple: 10650 },
      lift: { single: 12040, double: 12790, triple: 13590 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 430, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 },
        lift: { none: 0, 'recessed-lift-15': 450, 'recessed-lift-30': 530, 'recessed-lift-5': 990 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      }
    },
    specs: {
      power: '15,5 kW',
      efficiency: '78,6%',
      energyClass: 'A',
      glassSize: '717 x 471 mm',
      insertSize: '736 x 1114-1269 x 574 mm',
      fireplaceSize: '438 x 564 x 370 mm',
      maxLogLength: '530 mm',
      weight: '183 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4 w konfiguracji:\n\nModel: DRAGON 4\nMoc: 16 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },
  'dragon-2-xl': {
    id: 'dragon-2-xl',
    name: 'DRAGON 2 XL',
    power: '13 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-2-xl.jpg',
    emailSubject: 'Zapytanie - DRAGON 2 XL',
    description: 'Wkład powietrzny prosty 13 kW',
    basePrices: {
      standard: { single: 8670, double: 9370, triple: 10120 },
      lift: { single: 11610, double: 12310, triple: 13060 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 370, 'flush-30': 420, 'recessed-15': 490, 'recessed-30': 550, 'recessed-15-45': 600 },
        lift: { none: 0, 'recessed-lift-15': 440, 'recessed-lift-30': 510, 'recessed-lift-5': 960 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '13 kW',
      efficiency: '77,3%',
      energyClass: 'A',
      glassSize: '655 x 514 mm',
      insertSize: '708 x 1172-1327 x 450 mm',
      fireplaceSize: '488 x 500 x 254 mm',
      maxLogLength: '490 mm',
      weight: '155 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 2 XL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 2 XL w konfiguracji:\n\nModel: DRAGON 2 XL\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },
  'dragon-4-slim': {
    id: 'dragon-4-slim',
    name: 'DRAGON 4 SLIM',
    power: '14 kW',
    type: 'powietrzny',
    glassType: 'prosta' as const,
    image: 'images/dragon-4-slim.jpg',
    emailSubject: 'Zapytanie - DRAGON 4 SLIM',
    description: 'Wkład powietrzny prosty 14 kW',
    basePrices: {
      standard: { single: 8730, double: 9470, triple: 10280 },
      lift: { single: 11670, double: 12420, triple: 13220 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 430, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 },
        lift: { none: 0, 'recessed-lift-15': 450, 'recessed-lift-30': 530, 'recessed-lift-5': 990 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '14 kW',
      efficiency: '78,0%',
      energyClass: 'A',
      glassSize: '717 x 471 mm',
      insertSize: '790 x 1114-1269 x 474 mm',
      fireplaceSize: '438 x 596 x 285 mm',
      maxLogLength: '580 mm',
      weight: '177 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4 SLIM',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4 SLIM w konfiguracji:\n\nModel: DRAGON 4 SLIM\nMoc: 14 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },
  'dragon-4-xl-slim': {
    id: 'dragon-4-xl-slim',
    name: 'DRAGON 4 XL SLIM',
    power: '14 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-4-xl-slim.jpg',
    emailSubject: 'Zapytanie - DRAGON 4 XL SLIM',
    description: 'Wkład powietrzny prosty 14 kW',
    basePrices: {
      standard: { single: 9100, double: 9960, triple: 10920 },
      lift: { single: 12040, double: 12900, triple: 13860 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 410, 'flush-30': 450, 'recessed-15': 540, 'recessed-30': 590, 'recessed-15-45': 680 },
        lift: { none: 0, 'recessed-lift-15': 560, 'recessed-lift-30': 550, 'recessed-lift-5': 1010 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '14 kW',
      efficiency: '77,0%',
      energyClass: 'A',
      glassSize: '717 x 514 mm',
      insertSize: '790 x 1157-1312 x 474 mm',
      fireplaceSize: '480 x 564 x 285 mm',
      maxLogLength: '550 mm',
      weight: '175 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4 XL SLIM',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4 XL SLIM w konfiguracji:\n\nModel: DRAGON 4 XL SLIM\nMoc: 14 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },
  'dragon-4-xl': {
    id: 'dragon-4-xl',
    name: 'DRAGON 4 XL',
    power: '15,5 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-4-xl.jpg',
    emailSubject: 'Zapytanie - DRAGON 4 XL',
    description: 'Wkład powietrzny prosty 16 kW',
    basePrices: {
      standard: { single: 9740, double: 10600, triple: 11560 },
      lift: { single: 12680, double: 13540, triple: 14500 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 450, 'recessed-15': 540, 'recessed-30': 590, 'recessed-15-45': 680 },
        lift: { none: 0, 'recessed-lift-15': 560, 'recessed-lift-30': 550, 'recessed-lift-5': 1010 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '15,5 kW',
      efficiency: '78,6%',
      energyClass: 'A',
      glassSize: '717 x 514 mm',
      insertSize: '736 x 1157-1312 x 574 mm',
      fireplaceSize: '480 x 564 x 370 mm',
      maxLogLength: '550 mm',
      weight: '191 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4 XL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4 XL w konfiguracji:\n\nModel: DRAGON 4 XL\nMoc: 16 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },
  'dragon-6': {
    id: 'dragon-6',
    name: 'DRAGON 6',
    power: '12 kW',
    type: 'powietrzny',
    glassType: 'prosta' as const,
    image: 'images/dragon-6.jpg',
    emailSubject: 'Zapytanie - DRAGON 6',
    description: 'Wkład powietrzny prosty 12 kW',
    basePrices: {
      standard: { single: 8890, double: 9630, triple: 10440 },
      lift: { single: 11830, double: 12580, triple: 13380 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 360, 'flush-30': 410, 'recessed-15': 470, 'recessed-30': 540, 'recessed-15-45': 580 },
        lift: { none: 0, 'recessed-lift-15': 420, 'recessed-lift-30': 500, 'recessed-lift-5': 950 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '12 kW',
      efficiency: '78,0%',
      energyClass: 'A',
      glassSize: '754 x 381 mm',
      insertSize: '777 x 1020-1275 x 444 mm',
      fireplaceSize: '370 x 605 x 254 mm',
      maxLogLength: '600 mm',
      weight: '150 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 6',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 6 w konfiguracji:\n\nModel: DRAGON 6\nMoc: 12 kW\nKonfiguracią: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },
  'dragon-6-xl': {
    id: 'dragon-6-xl',
    name: 'DRAGON 6 XL',
    power: '12 kW',
    type: 'powietrzny',
    glassType: 'prosta' as const,
    image: 'images/dragon-6-xl.jpg',
    emailSubject: 'Zapytanie - DRAGON 6 XL',
    description: 'Wkład powietrzny prosty 12 kW',
    basePrices: {
      standard: { single: 9420, double: 10280, triple: 11240 },
      lift: { single: 12360, double: 13220, triple: 14180 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 440, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 },
        lift: { none: 0, 'recessed-lift-15': 450, 'recessed-lift-30': 530, 'recessed-lift-5': 990 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '12 kW',
      efficiency: '78,0%',
      energyClass: 'A',
      glassSize: '754 x 454 mm',
      insertSize: '777 x 1193-1348 x 444 mm',
      fireplaceSize: '440 x 605 x 254 mm',
      maxLogLength: '600 mm',
      weight: '176 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 6 XL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 6 XL w konfiguracji:\n\nModel: DRAGON 6 XL\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },
  'dragon-6-xxl': {
    id: 'dragon-6-xxl',
    name: 'DRAGON 6 XXL',
    power: '12 kW',
    type: 'powietrzny',
    glassType: 'prosta' as const,
    image: 'images/dragon-6-xxl.jpg',
    emailSubject: 'Zapytanie - DRAGON 6 XXL',
    description: 'Wkład powietrzny prosty 12 kW',
    basePrices: {
      standard: { single: 10010, double: 11080, triple: 12360 },
      lift: { single: 12950, double: 14020, triple: 15310 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 420, 'flush-30': 500, 'recessed-15': 550, 'recessed-30': 640, 'recessed-15-45': 690 },
        lift: { none: 0, 'recessed-lift-15': 510, 'recessed-lift-30': 580, 'recessed-lift-5': 1100 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '12 kW',
      efficiency: '78,0%',
      energyClass: 'A',
      glassSize: '754 x 604 mm',
      insertSize: '777 x 1343-1498 x 444 mm',
      fireplaceSize: '590 x 659 x 280 mm',
      maxLogLength: '650 mm',
      weight: '208 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 6 XXL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 6 XXL w konfiguracji:\n\nModel: DRAGON 6 XXL\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },
    'dragon-8': {
    id: 'dragon-8',
    name: 'DRAGON 8',
    power: '11 kW',
    type: 'powietrzny',
    glassType: 'prosta' as const,
    image: 'images/dragon-8.jpg',
    emailSubject: 'Zapytanie - DRAGON 8',
    description: 'Wkład powietrzny prosty 11 kW',
    basePrices: {
      standard: { single: 7660, double: 8240, triple: 8940 },
      lift: { single: 10600, double: 11190, triple: 11880 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 300, 'flush-30': 350, 'recessed-15': 390, 'recessed-30': 440, 'recessed-15-45': 490 },
        lift: { none: 0, 'recessed-lift-15': 360, 'recessed-lift-30': 410, 'recessed-lift-5': 780 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 235
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '11,5 kW',
      efficiency: '75,0%',
      energyClass: 'A',
      glassSize: '423 x 513 mm',
      insertSize: '449 x 1105-1187 x 500 mm',
      fireplaceSize: '495 x 382 x 360 mm',
      maxLogLength: '360 mm',
      weight: '126 kg'
    },
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 370/370/80 mm (21 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 8',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 8 w konfiguracji:\n\nModel: DRAGON 8\nMoc: 11 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-8-xxl': {
  id: 'dragon-8-xxl',
  name: 'DRAGON 8 XXL',
  power: '13 kW',
  type: 'powietrzny',
  glassType: 'prosta' as const,
  image: 'images/dragon-8-xxl.jpg',
  emailSubject: 'Zapytanie - DRAGON 8 XXL',
  description: 'Wkład powietrzny prosty 13 kW',
  basePrices: {
    standard: { single: 8190, double: 8990, triple: 9900 },
    lift: { single: 11130, double: 11940, triple: 12840 }
  },
  extraPrices: {
    ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
    handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
    bezel: {
      standard: { none: 0, 'flush-15': 360, 'flush-30': 410, 'recessed-15': 470, 'recessed-30': 540, 'recessed-15-45': 580 },
      lift: { none: 0, 'recessed-lift-15': 420, 'recessed-lift-30': 500, 'recessed-lift-5': 950 }
    },
    fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
    thermalModules: { none: 0, 'thermal': 235 },
    controllers: {
      'none': 0,
      'czujnik-drzwiczek': 215,
      'rt-08-om': 1510,
      'rt-08-om-grafik': 1610,
      'rt-08-om-grafik-wb': 1745,
      'rt-08-om-duo-integra': 2170,
      'rt-08-om-grafik-duo-integra': 2200,
      'rt-08-om-grafik-duo-integra-wb': 2300
    }
  },
  specs: {
    power: '13,7 kW',
    efficiency: '79,9%',
    energyClass: 'A',
    glassSize: '454 x 684 mm',
    insertSize: '488 x 1468-1550 x 492 mm',
    fireplaceSize: '670 x 370 x 340 mm',
    maxLogLength: '360 mm',
    weight: '185 kg'
  },
  
  labels: {
    variant: { 
      standard: 'Standard - otwieranie na bok', 
      lift: 'LIFT - podnoszenie do góry' 
    },
    glass: { 
      single: 'Pojedyncza x1', 
      double: 'Podwójna x2', 
      triple: 'Potrójna x3'
    },
    ceramic: { 
      'refrabox-light': 'Jasna Refrabox', 
      'cerabox-graphite': 'Grafitowa Cerabox' 
    },
    handle: { 
      'classic-black': 'Classic czarna', 
      'classic-silver': 'Classic srebrna',
      'design-black': 'Design czarna',
      'design-black-silver': 'Design czarno-srebrna'
    },
    bezel: { 
      none: 'Bez blendy', 
      'flush-15': 'Licująca 15mm (R15)',
      'flush-30': 'Licująca 30mm (R30)',
      'recessed-15': 'Zagłębiająca 15mm (RZ15)',
      'recessed-30': 'Zagłębiająca 30mm (RZ30)',
      'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
      'recessed-lift-15': 'LIFT 15mm (RL15)',
      'recessed-lift-30': 'LIFT 30mm (RL30)',
      'recessed-lift-5': 'LIFT 5mm (RL05)'
    },
    fusion: { 
      none: 'Brak',
      fusion: 'FUSION',
      'fusion-corner': 'FUSION CORNER'
    },
    thermalModules: {
      none: 'Brak',
      'thermal': 'MODUŁ 370/370/80 mm (21 kg)'
    },
    controllers: {
      'none': 'Brak',
      'czujnik-drzwiczek': 'Czujnik drzwiczek',
      'rt-08-om': 'RT-08 OM',
      'rt-08-om-grafik': 'RT-08 OM GRAFIK',
      'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
      'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
      'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
      'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
    }
  },
  emailTemplate: {
    subject: 'Zapytanie - DRAGON 8 XXL',
    body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 8 XXL w konfiguracji:\n\nModel: DRAGON 8 XXL\nMoc: 13 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
  }
},
  'dragon-8-mini': {
    id: 'dragon-8-mini',
    name: 'DRAGON 8 MINI',
    power: '9 kW',
    type: 'powietrzny',
    glassType: 'prosta' as const,
    image: 'images/dragon-8-mini.jpg',
    emailSubject: 'Zapytanie - DRAGON 8 MINI',
    description: 'Wkład powietrzny prosty 6 kW',
    basePrices: {
      standard: { single: 5460 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 300, 'flush-30': 410, 'recessed-15-45': 490 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { none: 0, 'thermal': 235 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '9 kW',
      efficiency: '76,0%',
      energyClass: 'A',
      glassSize: '300 x 400 mm',
      insertSize: '413 x 1010-1092 x 497 mm',
      fireplaceSize: '415 x 295 x 350 mm',
      maxLogLength: '290 mm',
      weight: '106 kg'
    },
    perkData: {
      variant: {
        standard: { icon: '🚪', value: 'Standard', color: '#4a9eff' }
      },
      glass: {
        single: { icon: '🪟', value: 'x1', color: '#e6f3ff' }
      },
      ceramic: {
        'refrabox-light': { icon: '🧱', value: 'Jasna', color: '#f5f1e8' },
        'cerabox-graphite': { icon: '🧱', value: 'Grafitowa', color: '#4a4a4a' }
      },
      handle: {
        'classic-black': { icon: '🔗', value: 'Classic', color: '#333' },
        'classic-silver': { icon: '🔗', value: 'Classic', color: '#c0c0c0' },
        'design-black': { icon: '🔗', value: 'Design', color: '#1a1a1a' },
        'design-black-silver': { icon: '🔗', value: 'Design', color: 'linear-gradient(45deg,#333,#c0c0c0)' }
      },
      bezel: {
        none: { icon: '⭕', value: 'Brak', color: '#666' },
        'flush-15': { icon: '⭕', value: 'Licująca', color: '#8b4513' },
        'flush-30': { icon: '⭕', value: 'Licująca', color: '#8b4513' },
        'recessed-15-45': { icon: '⭕', value: 'Zagłębiająca', color: '#654321' }
      },
      fusion: {
        none: { icon: '♨️', value: 'Brak', color: '#666' }
      }
    },
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Pojedyncza x1'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak'
      },
      thermalModules: {
        none: 'Brak',
        'thermal': 'MODUŁ 370/370/80 mm (21 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 8 MINI',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 8 MINI w konfiguracji:\n\nModel: DRAGON 8 MINI\nMoc: 6 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-8-slim': {
    id: 'dragon-8-slim',
    name: 'DRAGON 8 SLIM',
    power: '9 kW',
    type: 'powietrzny',
    glassType: 'prosta' as const,
    image: 'images/dragon-8-slim.jpg',
    emailSubject: 'Zapytanie - DRAGON 8 SLIM',
    description: 'Wkład powietrzny prosty 9 kW',
    basePrices: {
      standard: { single: 7440, double: 8030, triple: 8730 },
      lift: { single: 10380, double: 10970, triple: 11670 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 300, 'flush-30': 350, 'recessed-15': 390, 'recessed-30': 440, 'recessed-15-45': 490 },
        lift: { none: 0, 'recessed-lift-15': 360, 'recessed-lift-30': 410, 'recessed-lift-5': 780 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { none: 0, 'thermal': 235 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '9 kW',
      efficiency: '75,0%',
      energyClass: 'A',
      glassSize: '423 x 513 mm',
      insertSize: '478 x 1105-1187 x 409 mm',
      fireplaceSize: '495 x 328 x 260 mm',
      maxLogLength: '300 mm',
      weight: '117 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        none: 'Brak',
        'thermal': 'MODUŁ 370/370/80 mm (21 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 8 SLIM',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 8 SLIM w konfiguracji:\n\nModel: DRAGON 8 SLIM\nMoc: 9 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-9': {
  id: 'dragon-9',
  name: 'DRAGON 9',
  power: '14 kW',
  type: 'powietrzny',
  glassType: 'prosta' as const,
  image: 'images/dragon-9.jpg',
  emailSubject: 'Zapytanie - DRAGON 9',
  description: 'Wkład powietrzny prosty 14 kW',
  basePrices: {
    standard: { single: 11030, double: 11990, triple: 13170 },
    lift: { single: 13970, double: 14930, triple: 16110 }
  },
  extraPrices: {
    ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
    handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
    bezel: {
      standard: { none: 0, 'flush-15': 420, 'flush-30': 500, 'recessed-15': 550, 'recessed-30': 640, 'recessed-15-45': 680 },
      lift: { none: 0, 'recessed-lift-15': 510, 'recessed-lift-30': 580, 'recessed-lift-5': 1100 }
    },
    fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
    thermalModules: { 
      'none': 0, 
      'thermal': 260
    },
    controllers: {
      'none': 0,
      'czujnik-drzwiczek': 215,
      'rt-08-om': 1510,
      'rt-08-om-grafik': 1610,
      'rt-08-om-grafik-wb': 1745,
      'rt-08-om-duo-integra': 2170,
      'rt-08-om-grafik-duo-integra': 2200,
      'rt-08-om-grafik-duo-integra-wb': 2300
    }
  },
  specs: {
    power: '14 kW',
    efficiency: '78,0%',
    energyClass: 'A',
    glassSize: '904 x 454 mm',
    insertSize: '957 x 1139-1294 x 457 mm',
    fireplaceSize: '415 x 807 x 260 mm',
    maxLogLength: '805 mm',
    weight: '230 kg'
  },
  
  labels: {
    variant: { 
      standard: 'Standard - otwieranie na bok', 
      lift: 'LIFT - podnoszenie do góry' 
    },
    glass: { 
      single: 'Pojedyncza x1', 
      double: 'Podwójna x2', 
      triple: 'Potrójna x3'
    },
    ceramic: { 
      'refrabox-light': 'Jasna Refrabox', 
      'cerabox-graphite': 'Grafitowa Cerabox' 
    },
    handle: { 
      'classic-black': 'Classic czarna', 
      'classic-silver': 'Classic srebrna',
      'design-black': 'Design czarna',
      'design-black-silver': 'Design czarno-srebrna'
    },
    bezel: { 
      none: 'Bez blendy', 
      'flush-15': 'Licująca 15mm (R15)',
      'flush-30': 'Licująca 30mm (R30)',
      'recessed-15': 'Zagłębiająca 15mm (RZ15)',
      'recessed-30': 'Zagłębiająca 30mm (RZ30)',
      'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
      'recessed-lift-15': 'LIFT 15mm (RL15)',
      'recessed-lift-30': 'LIFT 30mm (RL30)',
      'recessed-lift-5': 'LIFT 5mm (RL05)'
    },
    fusion: { 
      none: 'Brak',
      fusion: 'FUSION',
      'fusion-corner': 'FUSION CORNER'
    },
    thermalModules: {
      'none': 'Brak',
      'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
    },
    controllers: {
      'none': 'Brak',
      'czujnik-drzwiczek': 'Czujnik drzwiczek',
      'rt-08-om': 'RT-08 OM',
      'rt-08-om-grafik': 'RT-08 OM GRAFIK',
      'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
      'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
      'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
      'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
    }
  },
  emailTemplate: {
    subject: 'Zapytanie - DRAGON 9',
    body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 9 w konfiguracji:\n\nModel: DRAGON 9\nMoc: 14 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
  }
 },
 'dragon-9-xl': {
  id: 'dragon-9-xl',
  name: 'DRAGON 9 XL',
  power: '14 kW',
  type: 'powietrzny',
  glassType: 'prosta' as const,
  image: 'images/dragon-9-xl.jpg',
  emailSubject: 'Zapytanie - DRAGON 9 XL',
  description: 'Wkład powietrzny prosty 14 kW',
  basePrices: {
    standard: { single: 12200, double: 13330, triple: 14660 },
    lift: { single: 15150, double: 16270, triple: 17610 }
  },
  extraPrices: {
    ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
    handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
    bezel: {
      standard: { none: 0, 'flush-15': 490, 'flush-30': 570, 'recessed-15': 640, 'recessed-30': 730, 'recessed-15-45': 800 },
      lift: { none: 0, 'recessed-lift-15': 580, 'recessed-lift-30': 670, 'recessed-lift-5': 1270 }
    },
    fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
    thermalModules: { 
      'none': 0, 
      'thermal': 260
    },
    controllers: {
      'none': 0,
      'czujnik-drzwiczek': 215,
      'rt-08-om': 1510,
      'rt-08-om-grafik': 1610,
      'rt-08-om-grafik-wb': 1745,
      'rt-08-om-duo-integra': 2170,
      'rt-08-om-grafik-duo-integra': 2200,
      'rt-08-om-grafik-duo-integra-wb': 2300
    }
  },
  specs: {
    power: '14 kW',
    efficiency: '78,0%',
    energyClass: 'A',
    glassSize: '904 x 514 mm',
    insertSize: '957 x 1199-1354 x 463 mm',
    fireplaceSize: '475 x 807 x 260 mm',
    maxLogLength: '805 mm',
    weight: '230 kg'
  },
  labels: {
    variant: { 
      standard: 'Standard - otwieranie na bok', 
      lift: 'LIFT - podnoszenie do góry' 
    },
    glass: { 
      single: 'Pojedyncza x1', 
      double: 'Podwójna x2', 
      triple: 'Potrójna x3'
    },
    ceramic: { 
      'refrabox-light': 'Jasna Refrabox', 
      'cerabox-graphite': 'Grafitowa Cerabox' 
    },
    handle: { 
      'classic-black': 'Classic czarna', 
      'classic-silver': 'Classic srebrna',
      'design-black': 'Design czarna',
      'design-black-silver': 'Design czarno-srebrna'
    },
    bezel: { 
      none: 'Bez blendy', 
      'flush-15': 'Licująca 15mm (R15)',
      'flush-30': 'Licująca 30mm (R30)',
      'recessed-15': 'Zagłębiająca 15mm (RZ15)',
      'recessed-30': 'Zagłębiająca 30mm (RZ30)',
      'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
      'recessed-lift-15': 'LIFT 15mm (RL15)',
      'recessed-lift-30': 'LIFT 30mm (RL30)',
      'recessed-lift-5': 'LIFT 5mm (RL05)'
    },
    fusion: { 
      none: 'Brak',
      fusion: 'FUSION',
      'fusion-corner': 'FUSION CORNER'
    },
    thermalModules: {
      'none': 'Brak',
      'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
    },
    controllers: {
      'none': 'Brak',
      'czujnik-drzwiczek': 'Czujnik drzwiczek',
      'rt-08-om': 'RT-08 OM',
      'rt-08-om-grafik': 'RT-08 OM GRAFIK',
      'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
      'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
      'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
      'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
    }
  },
  emailTemplate: {
    subject: 'Zapytanie - DRAGON 9 XL',
    body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 9 XL w konfiguracji:\n\nModel: DRAGON 9 XL\nMoc: 14 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
  }
 }
}



